import { api } from './client';
import { ADMIN_LOOKUP_SIZE, ADMIN_PAGE_SIZE } from './adminTypes';
function multipartHeaders() {
    return { headers: { 'Content-Type': undefined } };
}
export async function fetchAdminMediaPage(page = 0, size = ADMIN_PAGE_SIZE) {
    const res = await api.get('/v1/media', { params: { page, size } });
    return res.data;
}
export async function fetchAdminMediaLookup() {
    const res = await fetchAdminMediaPage(0, ADMIN_LOOKUP_SIZE);
    return res.content;
}
export async function uploadAdminMedia(file, type, name) {
    const body = new FormData();
    body.append('file', file);
    body.append('type', type);
    if (name?.trim())
        body.append('name', name.trim());
    const res = await api.post('/v1/media/upload', body, multipartHeaders());
    return res.data;
}
export async function uploadAdminMediaBatch(files, type) {
    const body = new FormData();
    files.forEach((file) => body.append('files', file));
    body.append('type', type);
    const res = await api.post('/v1/media/upload/batch', body, multipartHeaders());
    return res.data;
}
export async function updateAdminMedia(id, name, file) {
    const body = new FormData();
    body.append('name', name);
    if (file)
        body.append('file', file);
    const res = await api.put(`/v1/media/${id}`, body, multipartHeaders());
    return res.data;
}
export async function deleteAdminMedia(id) {
    await api.delete(`/v1/media/${id}`);
}
